const config = {
  development: {
    apiBaseUrl: 'https://digibyte.io',
    wsBaseUrl: 'wss://digibyte.io/ws',
  },
  production: {
    apiBaseUrl: 'https://digibyte.io',
    wsBaseUrl: 'wss://digibyte.io/ws', // Changed to wss:// from ws://
  },
};

const env = process.env.NODE_ENV || 'development';

export default config[env];
